<template>
  <!-- Indicadores -->
  <v-row v-if="getIdModule === '18'" class="full-height">
    <v-col cols="12">
      <v-btn color="primary" small block @click="onNuevoIndicador">
        <v-icon left>mdi-plus</v-icon> Crear
      </v-btn>
    </v-col>
    <v-col cols="12" class="full-height">
      <v-list dense class="full-height">
        <v-list-item-group v-model="menu">
            <v-list-item v-for="(item, index) in getAIndicadores" :key="index" :class="[index === getSeleccionado ? 'v-list-item--active v-item--active' : '']" :value="index">
                <v-list-item-content>
                <v-list-item-title> {{ item.indicador }} </v-list-item-title>
                </v-list-item-content>
                <v-hover v-slot:default="{ hover }">
                    <v-list-item-action>
                        <v-menu transition="scale-transition" right offset-x v-if="getAPermisos.priv_update === '1'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon x-small v-bind="attrs" v-on="on" :class="{ 'on-hover': hover }">
                                    <v-icon color="primary">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense expand>
                                <v-list-item class="custom-item">
                                    <v-btn color="secondary" text block small class="justify-start" @click.stop="onEditar(item)" >
                                        <v-icon left>mdi-pencil-outline</v-icon>
                                        {{ $store.state.jsIdioma.oEquivalencias.btnEditar }}
                                    </v-btn>
                                </v-list-item>
                                <v-list-item class="custom-item">
                                    <v-btn color="secondary" text block small class="justify-start" @click.stop="onOcultar(item)" >
                                        <v-icon left v-if="item.estado === '1'"> mdi-eye-off-outline</v-icon>
                                        <v-icon v-else>mdi-eye-outline</v-icon>
                                        {{ item.estado === "1" ? `${oEquivalencias.btnInactivar}` : `${oEquivalencias.btnActivar}` }}
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-list-item-action>
                </v-hover>
            </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menu: null,
      oEquivalencias: this.$store.state.jsIdioma.oEquivalencias
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch("indicadores/save_nuevo_indicador", false);
      setTimeout(() => this.$store.dispatch('save_b_expand_menu', true), 500);
      this.$emit("onForceExpand", true);
    })
  },
  methods: {
    onNuevoIndicador() {
      this.$store.dispatch("indicadores/save_nuevo_indicador", true);
    },
    onSeleccionar(item) {
      this.$store.dispatch("indicadores/save_seleccionado", item);
    },
    onEditar(item) {
      this.$store.dispatch("indicadores/save_seleccionadoEditar", item);
    },
    onOcultar(item) {
      this.$store.dispatch("indicadores/save_seleccionadoEstado", item);
    }
  },
  computed: {
    ...mapGetters("indicadores", ["getAIndicadores", "getSeleccionado","getAPermisos"]),
    ...mapGetters(["getbExpand"]),
    getIdModule() {
      return this.$store.getters.getIdModule;
    },
  },
  watch: {
    menu() {
      if (this.menu !== undefined) {
        const { indicador } = this.getAIndicadores[this.menu]
        if(indicador) this.$store.dispatch('save_s_titulomodulo', indicador)
        this.onSeleccionar(this.menu)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-item {
  min-height: 30px !important;
}
.on-hover {
    color: #000 !important;
}
</style>